import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import { useLanguageStore } from '@/stores/language'

export const useProfileStore = defineStore('profile', () => {
    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()
    const languageStore = useLanguageStore()

    const profile = ref({})
    const profileProcess = ref(false)
    const profileMsg = ref({})

    /**
     * Получает профиль пользователя
     *
     * @param {String} payload - UUID пользователя в системе
     */
    async function readProfile() {
        const token = tokenStore.access

        if (token) {
            profileProcess.value = true

            /**
             * Здесь берём UUID пользователя из localStorage, т.к. во время загрузки приложения в store UUID ещё нет
             */
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/users/${localStorage.getItem('ASW_UUID')}`,
                method: 'GET',
                token
            })

            if (!request.error) {
                profile.value = request
                profileMsg.value = { success: true }
                if(profile.code) languageStore.updateLanguage(profile.code)
            } else {
                profileMsg.value = { success: false, text: request.error }
                profileProcess.value = false
            }
        } else {
            profileMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        profileProcess.value = false

        return profile.value
    }

    return {
        profile,
        profileProcess,
        profileMsg,
        readProfile
    }
})
